export default __webpack_public_path__ + "static/media/front.a6f2d508.png";